export { Reveal } from "./Reveal"
export type { RevealProps } from "./Reveal"
